import { fonts } from './fonts';
import { fontSizes } from './fontSizes';
import { sizes } from './sizes';
import { colors } from './colors';
import { spacing } from './spacing';

export const tokens = {
	fonts,
	fontSizes,
	sizes,
	colors,
	spacing
};